(function($) {
    'use strict';

    class ApiService {
        constructor() {
            this.endpoint = salaryCalculatorData.ajaxurl;
            this.nonce = salaryCalculatorData.nonce;
            this.isLoading = false;
            this.currentRequest = null;
        }

        setLoading(status) {
            this.isLoading = status;
            const $button = $('.calculate-button');
            const $form_wrapper = $('.salary-calculator__form');
            const $get_email_button = $('.get-email-button');
            const $loader = $('.loader');
            const $results = $('.salary-calculator__results');
            const $resultBtn = $('.salary-calculator__result-btn');

            if (status) {
                $button.addClass('loading').prop('disabled', true);
                $form_wrapper.addClass('loading');
                $get_email_button.addClass('loading');
                $loader.addClass('active');
                $resultBtn.hide();
                if ($results.hasClass('active')) {
                    $results.addClass('loading');
                }
            } else {
                $button.removeClass('loading').prop('disabled', false);
                $form_wrapper.removeClass('loading');
                $get_email_button.removeClass('loading');
                $loader.removeClass('active');
                $results.removeClass('loading');
                $resultBtn.show();
            }
        }

        calculate(formData) {
            if (this.currentRequest) {
                this.currentRequest.abort();
            }

            this.setLoading(true);

            this.currentRequest = $.ajax({
                url: this.endpoint,
                type: 'POST',
                data: {
                    action: 'calculate_salary',
                    nonce: this.nonce,
                    ...formData
                }
            }).always(() => {
                this.setLoading(false);
                this.currentRequest = null;
            });

            return this.currentRequest;
        }

        sendReport(email) {
            return $.ajax({
                url: this.endpoint,
                type: 'POST',
                data: {
                    action: 'salary_calculator_send_report',
                    email: email,
                    nonce: this.nonce
                }
            });
        }

        generatePDF(data) {
            const $button = $('.sc_get_calculation_results__btn');
            $button.addClass('loading');

            return $.ajax({
                url: this.endpoint,
                type: 'POST',
                data: {
                    action: 'generate_salary_pdf',
                    current_url: window.location.href,
                    nonce: this.nonce,
                    ...data
                }
            }).always(() => {
                $button.removeClass('loading');
            });
        }
    }

    window.ApiService = ApiService;

})(jQuery); 